import { render, staticRenderFns } from "./InvoiceItemDataSidebar.vue?vue&type=template&id=916a37dc&scoped=true&"
import script from "./InvoiceItemDataSidebar.vue?vue&type=script&lang=js&"
export * from "./InvoiceItemDataSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "916a37dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('916a37dc')) {
      api.createRecord('916a37dc', component.options)
    } else {
      api.reload('916a37dc', component.options)
    }
    module.hot.accept("./InvoiceItemDataSidebar.vue?vue&type=template&id=916a37dc&scoped=true&", function () {
      api.rerender('916a37dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/invoice/invoice/components/InvoiceItemDataSidebar.vue"
export default component.exports